module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_faq_ro.5fc1cfa1.jpg";